import type { TableCallStateMessage } from "@bezoned/desktop-bridge/table-call-messaging.js";

import type { TableCallStatus } from "../../table-call/table-call.context.js";

export const mapTableCallStatus = (
  status: TableCallStatus
): TableCallStateMessage["payload"]["status"] => {
  if (status === "connected") {
    return "active";
  }

  if (status === "joining") {
    return "joining";
  }

  if (status === "leaving") {
    return "leaving";
  }

  return "disconnected";
};
